import { Pipe, PipeTransform } from '@angular/core';

import { RfqSessionBid } from '../models/rfq-session-bid';

@Pipe({
    name: 'supplierBids',
    standalone: false
})
export class SupplierBidsPipe implements PipeTransform {
	transform(bids: RfqSessionBid[], rfqSessionSupplierId: string): any {
		return bids && rfqSessionSupplierId ? bids.filter(b => b.rfqSessionSupplierId === rfqSessionSupplierId) : bids;
	}
}
